import { useQuery } from '@tanstack/react-query'

import { errorToast } from 'common/components/toastNotification'
import { useAppSelector } from 'common/hooks/redux'

import { fetchHeaders } from '../api'
import { personalizationKeys } from '../queryKeys'

const useGetHeadersQuery = () => {
  const accountId = useAppSelector((state) => state.authStates.accountId)

  const query = useQuery(
    personalizationKeys.filters,
    () => fetchHeaders(accountId),
    {
      onError: () => {
        errorToast('Something went wrong. Please try again.')
      },
    }
  )

  return query
}

export default useGetHeadersQuery
